import React, { useEffect, useState } from 'react';
import BrowserFrame from './BrowserFrame';

const SecurityOps: React.FC = () => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1500);
    return () => clearInterval(id);
  }, []);

  const alerts = [
    { time: `${14 + (tick % 3)}:2${tick % 10}`, type: 'BLOCKED', msg: 'Brute-force · 185.220.*', color: '#4ADE80' },
    { time: `${14 + (tick % 3)}:1${(tick + 5) % 10}`, type: 'INFO', msg: 'Scan port 22 · WAF active', color: '#7AAABF' },
    { time: `${14 + (tick % 3)}:0${(tick + 7) % 10}`, type: 'BLOCKED', msg: 'SQL injection attempt', color: '#4ADE80' },
    { time: `${13 + (tick % 3)}:5${(tick + 2) % 10}`, type: 'WARN', msg: 'Failed login · admin', color: '#FBBF24' },
  ];

  const threats = 2847 + (tick % 47);

  return (
    <BrowserFrame url="soc.miid.app" darkChrome>
      <div style={{ padding: '1rem', background: '#0A1929', minHeight: '260px', fontFamily: "'Montserrat', sans-serif", color: '#FFFFFF' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.7rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="var(--gold)" strokeWidth="1.5">
              <path d="M10 2l7 3v5c0 4-3 7-7 8-4-1-7-4-7-8V5l7-3z" />
              <path d="M7 10l2 2 4-4" />
            </svg>
            <div>
              <div style={{ fontSize: '.7rem', fontWeight: 700 }}>Security Operations Center</div>
              <div style={{ fontSize: '.42rem', color: 'rgba(255,255,255,.45)', letterSpacing: '.12em', textTransform: 'uppercase', fontWeight: 600 }}>24/7 · Real-time monitoring</div>
            </div>
          </div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '.3rem', padding: '.15rem .45rem', background: 'rgba(46,125,50,.18)', border: '1px solid rgba(74,222,128,.3)', borderRadius: '2px' }}>
            <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#4ADE80', animation: 'livePulse 1.4s ease-in-out infinite' }} />
            <span style={{ fontSize: '.45rem', fontWeight: 700, color: '#4ADE80', letterSpacing: '.1em' }}>OPERATIONAL</span>
          </div>
        </div>

        {/* KPIs */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '.4rem', marginBottom: '.6rem' }}>
          {[
            { label: 'Bloqués 24h', value: threats.toLocaleString('fr'), color: '#4ADE80' },
            { label: 'Critiques', value: '0', color: '#4ADE80' },
            { label: 'Warnings', value: '3', color: '#FBBF24' },
            { label: 'Firewall', value: '✓ UP', color: 'var(--gold)' },
          ].map((k) => (
            <div key={k.label} style={{
              background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.08)',
              padding: '.4rem .5rem', borderRadius: '2px',
            }}>
              <div style={{ fontSize: '.42rem', color: 'rgba(255,255,255,.5)', letterSpacing: '.1em', textTransform: 'uppercase', fontWeight: 600 }}>{k.label}</div>
              <div style={{ fontSize: '.85rem', fontWeight: 700, color: k.color, fontFamily: "'Cormorant Garamond', serif", lineHeight: 1, marginTop: '.15rem' }}>{k.value}</div>
            </div>
          ))}
        </div>

        {/* Map + alerts */}
        <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '.5rem' }}>
          {/* Mini threat map */}
          <div style={{
            background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.08)',
            padding: '.5rem', borderRadius: '2px', position: 'relative',
          }}>
            <div style={{ fontSize: '.42rem', color: 'rgba(255,255,255,.5)', letterSpacing: '.1em', textTransform: 'uppercase', fontWeight: 600, marginBottom: '.3rem' }}>Threats by region</div>
            <svg viewBox="0 0 180 70" style={{ width: '100%', height: '70px' }}>
              {/* World silhouette (abstract) */}
              <path d="M 15 30 Q 30 25 50 32 Q 70 28 90 30 L 120 32 Q 150 28 170 35 Q 165 45 150 48 L 100 50 Q 80 52 50 48 L 30 46 Q 20 42 15 30 Z"
                    fill="rgba(255,255,255,.08)" stroke="rgba(255,255,255,.15)" strokeWidth=".5" />
              {/* Threat dots */}
              {[
                { x: 50, y: 35, intensity: 1 },
                { x: 90, y: 38, intensity: .8 },
                { x: 130, y: 32, intensity: .6 },
                { x: 155, y: 45, intensity: .4 },
                { x: 35, y: 40, intensity: .5 },
              ].map((d, i) => (
                <g key={i}>
                  <circle cx={d.x} cy={d.y} r="2" fill="#C62828" opacity={d.intensity}>
                    <animate attributeName="r" values="2;5;2" dur={`${1.5 + i * 0.3}s`} repeatCount="indefinite" />
                    <animate attributeName="opacity" values={`${d.intensity};0;${d.intensity}`} dur={`${1.5 + i * 0.3}s`} repeatCount="indefinite" />
                  </circle>
                  <circle cx={d.x} cy={d.y} r="1.2" fill="#FF6B6B" />
                </g>
              ))}
            </svg>
          </div>

          {/* Alert feed */}
          <div style={{
            background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.08)',
            padding: '.4rem .5rem', borderRadius: '2px',
          }}>
            <div style={{ fontSize: '.42rem', color: 'rgba(255,255,255,.5)', letterSpacing: '.1em', textTransform: 'uppercase', fontWeight: 600, marginBottom: '.3rem' }}>Live feed</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '.25rem', fontFamily: 'monospace' }}>
              {alerts.map((a, i) => (
                <div key={i} style={{ display: 'flex', gap: '.3rem', fontSize: '.42rem', color: 'rgba(255,255,255,.75)' }}>
                  <span style={{ color: 'rgba(255,255,255,.4)' }}>{a.time}</span>
                  <span style={{ color: a.color, fontWeight: 700 }}>{a.type}</span>
                  <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.msg}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
};

export default SecurityOps;
